module.exports = __webpack_public_path__ + "img/111598095025_.pic.bc9a3de3.jpg";